/**
 * Returns if an element is wider than its container
 * e.g. useful to detect if an element has an active text-overflow CSS property
 */
export const hasHorizontalOverflow = (el: HTMLElement) => el.scrollWidth > el.offsetWidth;

export const isHtmlElementNode = (node: Node): node is HTMLElement =>
  node.nodeType === Node.ELEMENT_NODE;

export const isImageElement = (element: HTMLElement): element is HTMLImageElement =>
  element.tagName === 'IMG';
